import { axios } from '@/lib/axios'

const CrudService = (resource) => {
  return {
    fetchAll: async ({ page = 1, pageSize = 20, sortBy = '', orderBy = '', filters = {} }, listType = '') => {
      try {
        let url = `${resource}${listType === '' ? '' : `/${listType}`}?page=${page}&limit=${pageSize}`

        if (sortBy !== '') {
          url += `&sortBy=${sortBy}&orderBy=${orderBy}`
        }

        for (const [filterKey, filterValue] of Object.entries(filters)) {
          url += `&${filterKey}=${encodeURIComponent(filterValue)}`
        }

        const response = await axios.get(url)
        if (!response?.data?.data) {
          throw new Error(response?.message || 'Unexpected Error')
        }

        return response.data
      } catch (error) {
        console.error('Error fetching data', error)
        throw error
      }
    },

    // Fetch a single resource by ID
    fetchOne: async (id) => {
      try {
        const response = await axios.get(`/${resource}/${id}`)
        return response.data
      } catch (error) {
        console.error(`Error fetching data with id ${id}`, error)
        throw error
      }
    },

    //Fetch Specific List

    // Create a new resource
    create: async (data) => {
      try {
        const response = await axios.post(`/${resource}`, data)
        return response.data
      } catch (error) {
        console.error('Error creating data', error)
        throw error
      }
    },

    // Update an existing resource by ID
    update: async (id, data) => {
      try {
        console.log(' id, dat', id, data)
        const response = await axios.put(`/${resource}/${id}`, data)
        return response.data
      } catch (error) {
        console.error(`Error updating data with id ${id}`, error)
        throw error
      }
    },

    // Delete a resource by ID
    remove: async (id) => {
      try {
        const response = await axios.delete(`/${resource}/${id}`)
        return response.data
      } catch (error) {
        console.error(`Error removing data with id ${id}`, error)
        throw error
      }
    },
  }
}

export default CrudService
